import { useEffect } from "react"

import { startMusic } from "src/utils/audio"

/* Ask for a bed while this view is mounted, and hand back to the menu's when it goes. The whole
   hook is the effect: `startMusic` is idempotent for a track already playing, so a re-render costs
   nothing and a route change costs one crossfade.
 *
 * The cleanup returns to `main` rather than stopping, because there is no screen in this app with
 * no music — leaving a game means arriving at the home page, and silence there would read as the
 * sound having broken. `stopMusic` exists for the one case that is genuinely silent: the volume
 * being set to zero. */
const useMusic = (track) => {
  useEffect(() => {
    startMusic(track)
    return () => startMusic("main")
  }, [track])
}

export default useMusic
